import { Omit } from '@40seas/entities/common';
import { BaseEntityFieldsArray } from '@40seas/models';
import { Quote } from './quote.entity';
import { QuoteStatus } from './quote.status.enum';

export class CreateQuoteDto extends Omit(Quote, [...BaseEntityFieldsArray, 'status'], ['status']) {
    status?: QuoteStatus;
}
